import type { FolderTextFieldOperation } from 'owa-mail-folder-store/lib/store/schema/FolderTextFieldViewState';
import { default as viewStateStore } from 'owa-mail-folder-store/lib/store/store';
import {
    ARCHIVE_FOLDERS_TREE_TYPE,
    SHARED_FOLDERS_TREE_TYPE,
    PRIMARY_FOLDERS_TREE_TYPE,
    GROUPS_FOLDERS_TREE_TYPE,
} from 'owa-folders-constants';

export function shouldRenderNodeInEditMode(
    folderId: string,
    operation: FolderTextFieldOperation,
    mailboxSmtpAddress: string
): boolean {
    const folderTextFieldViewState = viewStateStore.folderTextFieldViewState;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (19,5): Type 'boolean | null' is not assignable to type 'boolean'.
    // @ts-expect-error
    return (
        folderTextFieldViewState &&
        folderTextFieldViewState.folderId === folderId &&
        folderTextFieldViewState.operation === operation &&
        folderTextFieldViewState.mailboxSmtpAddress.toLowerCase() ===
            mailboxSmtpAddress.toLowerCase() &&
        (folderTextFieldViewState.folderNodeType === PRIMARY_FOLDERS_TREE_TYPE ||
            folderTextFieldViewState.folderNodeType === ARCHIVE_FOLDERS_TREE_TYPE ||
            folderTextFieldViewState.folderNodeType === SHARED_FOLDERS_TREE_TYPE ||
            folderTextFieldViewState.folderNodeType === GROUPS_FOLDERS_TREE_TYPE)
    );
}
